import useGlobalState from '@components/Hooks/useGlobalState';
import Error from '@Shared/Error';
import React from 'react';

const LoginError: React.FC = () => {

  const [store,] = useGlobalState();

  return store.login?.error ? (
    <Error>
      <h2>Login Error</h2>
      <p>{store.login.reason}</p>
    </Error>
  ) : null;
}

export default LoginError;